/**
* Events Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Events Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'events-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.events-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--events-slider' )[0], {
          pagination: false,
          perPage: 3,
          perMove: 1,
          gap: '32px',
          keyboard: true,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );
        const bar = $( component ).find( '.slider-progress-bar' )[0];

        splide.on( 'mounted move', function() {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min( ( splide.index + 1 ) / end, 1 );
          bar.style.width = String( 100 * rate ) + '%';
        } );

        splide.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'events-slider', COMPONENT );
} )( app );
